/**
 * Gets the page title.
 * @returns Current title.
 */
export function getHTMLTitle() {
    const titleElement = document.querySelector('title');
    return titleElement === null || titleElement === void 0 ? void 0 : titleElement.innerText;
}
